<template>
	<div class="personal">
		<div class="insert-title">个人信息</div>
		<el-form
			:model="formData"
			:rules="rules"
			inline
			:hide-required-asterisk="true"
			ref="personal"
		>
			<el-form-item
				prop="mobile"
				label-width="90px" >
				<div class="label qjc-fts-14" slot="label">
					病人手机号
				</div>
				<div class="open-item-tip" v-show="isShowPhone">{{formData.mobile}}</div>
				<el-input
					:disabled="true"
					v-model="formData.mobile"
					type="text"
					placeholder="请输入病人手机号"
					@input="phoneMustNumber"
				></el-input>
			</el-form-item>
			<el-form-item
				prop="sex"
				label-width="90px"
			>
				<div class="label qjc-fts-14" slot="label">
					用户性别
				</div>
				<el-select
					v-model="formData.sex"
				>
					<el-option
						label="男"
						:value="1"
					></el-option>
					<el-option
						label="女"
						:value="2"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item
				prop="birth"
				label-width="90px"
			>
				<div class="label qjc-fts-14" slot="label">
					出生日期
				</div>
				<el-date-picker
				  v-model="birthSel"
				  type="date"
				  placeholder="请选择"
				  value-format="timestamp"
				  :default-value="new Date('1990/1/1').getTime()"
				>
				</el-date-picker>
			</el-form-item>
			<el-form-item
				prop="examdate"
				label-width="90px"
			>
				<div class="label qjc-fts-14" slot="label">
					体检日期
				</div>
				<el-date-picker
				  v-model="examdateSel"
				  type="date"
				  placeholder="请选择"
				  value-format="timestamp"
				  :default-value="new Date().getTime()"
				>
				</el-date-picker>
			</el-form-item>
			<el-form-item
				prop="doctor"
				label-width="90px" >
				<div class="label qjc-fts-14" slot="label">
					负责医生
				</div>
				<el-input
					v-model="formData.doctor"
					type="text"
					placeholder="请输入负责医生姓名"
				></el-input>
			</el-form-item>
			
			<el-form-item
				prop="package"
				class="wid-100"
				label-width="90px" >
				<div class="label qjc-fts-14" slot="label">
					套餐内容
				</div>
				<div class="package">
					<div class="package-radio">
						<el-radio v-model="isPackage" label="1" border>M20大数据体检套餐</el-radio>
					</div>
				</div>
			</el-form-item>
			
			<div class="footer-btn">
				<!-- <el-button @click="handlePrev" class="prev qjc-fts-16 qjc-block">返回</el-button> -->
				<el-button @click="next" class="next qjc-fts-16 qjc-block">下一步</el-button>
			</div>
			
		</el-form>
	</div>
</template>

<script>
	import { isPhone } from '@/utils'
	import { getPackage, enterpriseList } from '@/utils/axios'
	
	export default{
		name: 'personal',
		data() {
			// 验证
			// 手机号
			var mobileVerify = (rule, value, callback) => {
				if(this.formData.yyuserid){
					if(value == ''){
						callback();
					}else if(isPhone(value)){
						callback();
					}else{
						callback(new Error('手机号格式错误'));
					}
				}else{
					if(value == ''){
						callback(new Error('手机号与企业用户ID至少填写一项'));
					}else if(isPhone(value)){
						callback();
					}else{
						callback(new Error('手机号格式错误'));
					}
				}
			}
			
			// 企业用户id验证
			var yyuseridVerify = (rule, value, callback) => {
				if(this.formData.mobile){
					callback();
				}else{
					if(value == ''){
						callback(new Error('手机号与企业用户ID至少填写一项'));
					}else{
						callback();
					}
				}
			}
			
			// 出生日期验证
			var birthVerify = (rule, value, callback) => {
				if(this.birthSel > this.limitTime(90) && this.birthSel <= this.limitTime(20)){
					callback();
				}else{
					callback(new Error('大数据评估仅适用于年龄在20~90周岁之间人群!'));
				}
			}
			
			// 体检日期验证
			var examdateVerify = (rule, value, callback) => {
				if(this.birthSel == '') {
					callback(new Error('请选择出生日期'));
				}
				if(this.examdateSel == '') {
					callback(new Error('请选择体检日期'));
				} else {
					let nowDate = new Date();
					let nowTime = new Date(nowDate.getFullYear() + '/' + (nowDate.getMonth()+1) + '/' + nowDate.getDate()).getTime();// 当前日期时间戳
					let birthTime = this.birthSel
					if(nowTime >= this.examdateSel && birthTime < this.examdateSel ){
						callback();
					}else{
						callback(new Error('体检日期大于出生日期且不能大于当前时间'));
					}
				}
				
				if(this.examdateSel == '') {
					callback();
				} else {
					let nowDate = new Date();
					let nowTime = new Date(nowDate.getFullYear() + '/' + (nowDate.getMonth()+1) + '/' + nowDate.getDate()).getTime();// 当前日期时间戳
					if(nowTime < this.examdateSel){
						callback(new Error('体检日期不能大于当前时间'));
					}else{
						callback();
					}
				}
			}
			
			// 基础套餐必选
			var examBasicVerify = (rule, value, callback) => {
				callback()
				// if(value.indexOf('base') != -1){
				// 	callback();
				// }else{
				// 	callback(new Error('基础体检套餐必选'));
				// }
			}
			
			return {
				mobileConfirm: '',// 手机号确认
				mobileConfirmErr: false,// 手机号确认错误消息显示
				
				yyuseridConfirm: '',// 企业用户id确认
				yyuseridConfirmErr: false,// 手机号确认错误消息显示
				isPackage: '1',
				rules: {
					mobile: [
						{ validator: mobileVerify, trigger: 'blur' }
					],
					sex: [
						{ required: true, message: '请选择客户性别', trigger: 'blur' }
					],
					birth: [
						{ required: true, message: '请选择出生日期', trigger: 'blur' },
						{ validator: birthVerify, trigger: 'change' }
					],
					// examdate: [
					// 	{ required: false, message: '请选择体检日期', trigger: 'blur' },
					// 	{ validator: examdateVerify, trigger: 'change' }
					// ],
					
				}, 
				
				count: {
					base: {
						times: 0//默认为0 
					},
					packageA: {
						times: 0//默认为0
					},
					packageB: {
						times: 0//默认为0
					},
					packageC: {
						times: 0//默认为0
					},
					packageD: {
						times: 0//默认为0
					}
				},//套餐剩余次数
				packageList: [],
				package_opt: '1',
				pay_mode: '1',
				// 体检日期不能选择今日以前
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 8.64e7;
					}
				},
				
				isShowPhone: false,
				companyList: [],
				packageValue: '',
				checkCustomList: [],
				corpname: '',
				isSuper: 0
			}
		},
		computed: {
			birthSel: {// 出生日期展示
				get() {
					if(this.formData.birth){//不能为空
						// 时间戳妙转为毫秒
						return this.formData.birth*1000;
					}else{
						return '';
					}
					
				},
				set(value) {
					// 毫秒转换为秒
					this.formData.birth = value/1000;
					
				}
			},
			examdateSel: {// 体检日期展示
				get() {
					if(this.formData.examdate){//不能为空
						// 时间戳妙转为毫秒
						return this.formData.examdate * 1000;
					}else{
						return '';
					}
				},
				set(value) {
					// 毫秒转换为秒
					this.formData.examdate = value/1000;
				}
			}
		},
		props: ['type', 'isBo', 'dataId', 'formData', 'reportCode', 'tel', 'doctor_id'],
		mounted() {
			let isSuper = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).issupper : ''
			this.isSuper = isSuper
			setTimeout(() => {
				if(this.formData.sex != '') {
					this.formData.sex = Number(this.formData.sex)
				}
				this.formData.mobile = this.tel;
				this.formData.id = this.dataId;
				this.formData.doctor_id = this.doctor_id;
				if(this.formData.examdate){
					
				} else {
					this.examdateSel = Date.parse(new Date());
				}
			},500)
		},
		watch:{
			
		},
		methods: {
			
			next() {
				this.$refs.personal.validate((isSuc, err) => {
					// 验证通过且确认输入也通过
					if(isSuc){
						
						this.$emit('stopQuery');
						
						// 成功进入下一步
						this.$emit('checkTab', 'Questions');
					}
				});
				
			},
			
			// 手机号确认
			mobileConfirmVerify() {
				if(this.mobileConfirm != this.formData.mobile){
					this.mobileConfirmErr = true;
					return false;
				}else{
					this.mobileConfirmErr = false;
					return true;
				}
			},
			
			// 企业用户id确认
			yyuseridConfirmVerify() {
				if(this.yyuseridConfirm != this.formData.yyuserid){
					this.yyuseridConfirmErr = true;
					return false;
				}else{
					this.yyuseridConfirmErr = false;
					return true;
				}
			},
			
			// 距今year年的时间戳 参数:year:距今年份
			limitTime(year) {
				let nowDate = new Date();
				return new Date((nowDate.getFullYear() - year) +'/' + (nowDate.getMonth() + 1) + '/' + nowDate.getDate()).getTime();
			},
			
			// 手机号必须输入数字
			phoneMustNumber(value) {
				this.formData.mobile = value.replace(/\D/g,'');
				this.isShowPhone = true
				setTimeout(() => {
					this.isShowPhone = false
				}, 5000)
			},
			phoneConfirmMustNumber(value) {
				this.mobileConfirm = value.replace(/\D/g,'');
			}
		}
	}
</script>

<style scoped>
	.el-form >>> .el-form-item__label{
		line-height: 36px;
	}
	.el-form .el-input >>> input,
	.el-form >>> .el-input__inner{
		height: 36px;
		line-height: 16px;
		font-size: 14px;
	}
	.el-form >>> .el-form-item__content,
	.el-form >>> .el-input__icon{
		line-height: 36px;
	}
	.product .el-checkbox,
	.product >>> .el-checkbox__input{
		position: absolute;
		top: 0;
		left: 0;
	}
	.product >>> .el-checkbox__inner{
		width: 18px;
		height: 16px;
		border-radius: 6px 0 6px 0;
	}
	.product >>> .el-checkbox__inner::after{
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%)rotate(45deg)scaleY(0);
	}
	.product >>> .el-checkbox__input.is-checked .el-checkbox__inner::after{
		transform: translate(-50%,-50%)rotate(45deg)scaleY(1);
	}
	.product >>> .el-checkbox__input.is-checked .el-checkbox__inner, 
	.product >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner{
		border-color: #6681FA;
		background-color: #6681FA;
	}
	.packages >>> .el-checkbox__label{
		display: none;
	}
	.packages >>> .el-form-item__content{
		width: 100%;
	}
	.packages >>> .el-form-item__error{
		position: absolute;
		top: 28px;
		left: 200px;
	}
	.el-form >>> .el-checkbox__label {
		font-size: 14px;
	}
	
	.wid-100 >>> .el-form-item__content {
		flex: 1;
	}
	
	.el-form >>> .is-checked .el-checkbox__input.is-disabled+span.el-checkbox__label {
		color: #6883FB;
	}
	.el-form >>> .is-checked .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
		border-color: #6681FA;
		background-color: #6681FA;
	}
	.el-form >>> .el-radio.is-bordered.is-checked {
		border-color: #6681FA
	}
	.el-form >>> .is-checked .el-radio__input.is-disabled+span.el-radio__label {
		color: #6681FA;
	}
	.el-form >>> .is-checked .el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner {
		background-color: #6681FA;
	}
</style>
<style lang="scss" scoped>
	.personal{
		padding-top: 50px;
		
		.open-item-tip {
				position: absolute;
				top: -40px;
				left: 0px;
				width: 438px;
				height: 40px;
				padding: 0 16px;
				line-height: 40px;
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #293033;
				background-color: #FFFFFF;
				box-shadow: 0px 1px 4px 0px #D7E0ED;
				border-radius: 2px;
			}
		
		.insert-title {
			position: relative;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #293033;
			line-height: 16px;
			padding-bottom: 15px;
			border-bottom: 1px solid #E5E8F5;
			margin-bottom: 32px;
			
			&::before{
				position: absolute;
				left: -24px;
				top: 0;
				content: '';
				width: 4px;
				height: 20px;
				background-color: #6883FB;
			}
		}
		
		.el-form{
			.el-form-item{
				width: 50%;
				margin-right: 0;
				margin-bottom: 12px;
				
				.label{
					display: flex;
					justify-content: flex-end;
					color: #777F8F;
				}
				.el-input,
				.el-select{
					width: 480px;
				}
				.tip{
					line-height: 12px;
					margin-top: 6px;
					color: #ACAEB3;
				}
				.product{
					width: 193px;
					height: 56px;
					line-height: 18px;
					border-radius: 6px 0 6px 0;
					cursor: pointer; 
					
					.name{
						top: 50%;
						left: 50%;
						width: 100%;
						transform: translate(-50%,-50%);
					}
					
					&.basic{
						color: #40444D;
						background-color: #F0F4F7;
					}
					&.PLM{
						color: #C07E37;
						background-color: #FCF9F0;
					}
					&.comorbidity{
						color: #C92B5C;
						background-color: #FCF5F2;
					}
					&.illness{
						color: #5843BE;
						background-color: #F6F5FC;
					}
					&.health{
						color: #1955AF;
						background-color: #F0F6FC;
					}
				}
				p.base-count{
					width: 193px;
					margin-bottom: 16px;
				}
				.count{
					font-size: 13px;
					line-height: 13px;
					color: #777F8F;
					margin-top: 6px;
				}
			}
			.packages{
				width: 100%;
				margin: 16px 0 0;
				
				.el-checkbox-group{
					display: flex;
					flex-wrap: wrap;
					
					div.qjc-fl{
						margin-right: 16px;
					}
					
					.c-danger{
						color: #FF4C52;
					}
				}
			}
			h3{
				margin: 40px 0 24px;
			}
			.footer-btn {
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 40px;
			}
			.next{
				width: 96px;
				height: 34px;
				border-radius: 17px;
				border: none;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 400;
				color: #fff;
			}
			.prev {
				width: 96px;
				height: 34px;
				border-radius: 17px;
				border: 1px solid #6883FB;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				background-color: #fff;
				margin-right: 24px;
			}
		}
	}
	
	.package-radio {
		margin-bottom: 12px;
	}
	.wid-100 {
		display: flex;
		width: 100% !important;
	}
	
	.package {
		
	}
	
	.package-radio {
		width: 480px;
		
		.el-radio.is-bordered {
			width: 480px;
		}
	}
	
	.custom-box {
		width: 100%;
		padding: 12px;
		border: 1px solid #DBDDE6;
	}
	
	.wid-100 .el-form-item__content {
		flex: 1;
	}
</style>
